import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';

import {
    APIUserClaimMembershipDelete,
    APIUserClaimMembershipGetList,
    APIUserClaimMembershipPost,
    APIUserClaimMembershipPostParams,
    APIUserClaimMembershipPostResponse,
    APIUserClaimMembershipPut,
    APIUserClaimMembershipPutParams,
    APIUserClaimMembershipPutResponse
} from './UserClaimMembership.api';

export type UserClaim = {
    id: string;
    claimId: string;
    userId: string;
    claimName: string;
}

export const fetchUserClaimMemberships = createAsyncThunk('users/fetchUserClaimMembershipList', async (item: {tenantId: string, userId: string, signal?: AbortSignal}) => {
    const response = await APIUserClaimMembershipGetList(item);
    return _formatUserClaimMemebershipResponse(response.data);
});

export type PostUserClaimThunkResponse = {
    response: APIUserClaimMembershipPostResponse,
    rows: UserClaim[]
}

export const postUserClaimMembership = createAsyncThunk('users/postUserClaimMembership', async (item: APIUserClaimMembershipPostParams) => {
    const response = await APIUserClaimMembershipPost(item);
    const rows = await handleListFetch(APIUserClaimMembershipGetList({ tenantId: item.tenantId, userId: item.userId }));
    return {
        response,
        rows: _formatUserClaimMemebershipResponse(rows)
    };
});

export type PutUserClaimThunkResponse = {
    response: APIUserClaimMembershipPutResponse,
    rows: UserClaim[]
}

export const putUserClaimMembership = createAsyncThunk('users/putUserClaimMembership', async (item: APIUserClaimMembershipPutParams) => {
    const response = await APIUserClaimMembershipPut(item);
    const rows = await handleListFetch(APIUserClaimMembershipGetList({ tenantId: item.tenantId, userId: item.userId }));
    return {
        response,
        rows: _formatUserClaimMemebershipResponse(rows)
    };
});

export const deleteUserClaimMembership = createAsyncThunk('users/deleteUserClaimMembership', async (item: { tenantId: string, userId: string, claimId: string }) => {
    const response = await APIUserClaimMembershipDelete(item);
    const rows = await handleListFetch(APIUserClaimMembershipGetList({ tenantId: item.tenantId, userId: item.userId }));
    return {
        response,
        rows: _formatUserClaimMemebershipResponse(rows),
    };
});

const _formatUserClaimMemebershipResponse = (rows: {
    claimId: string;
    userId: string;
    claimName: string;
}[]) => rows.map(item => ({
    ...item,
    id: item.claimId
}));
